/***
 * Created on 2023/8/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import { useStore } from "zustand";
import { createStore } from 'zustand/vanilla';
import {detectDefaultLanguage} from "../service/common";


export const store = createStore( (set) => ({
    globalAlert: {
        show: false,
        message: '',
        status: '',
        setShow: (value) => set(state => ({globalAlert: {...state.globalAlert, show: value}})),
        setMessage: (value) => set(state => ({globalAlert: {...state.globalAlert, message: value}})),
        setStatus: (value) => set(state => ({globalAlert: {...state.globalAlert, status: value}})),
        setAlert: (message, status, show) => set(state => ({globalAlert: {...state.globalAlert, message, status, show}})),
    },
    language: detectDefaultLanguage() || 'en',
    setLanguage: (value) => set(state => ({language: value})),
    currentUser: () => JSON.parse(localStorage.getItem('currentUser')),
    setCurrentUser: (value) => set(state => ({...state, currentUser: value}))
}))

export const useBoundedStore = () => useStore(store);
